<div class="main-section">
  <div class="top-section">
    <div class="icon-circle">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d92d20" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
      </svg>
    </div>
    <div class="popup-profile-name">Delete Blog?</div>
  </div>
  <div class="light-text">If you delete this blog, you cannot recover it. This action cannot be undone.</div>
  <div class="button-section">
    <button class="sec-btn" (click)="cancelBlog()">Cancel</button>
    <button class="btn-name" (click)="deleteBlog()" [disabled]="isLoading">
      <span *ngIf="!isLoading">Yes, Delete</span>
      <span *ngIf="isLoading">Deleting...</span>
    </button>
  </div>
</div>

